import { Button, Modal, Typography } from "antd";
import React from "react";

const { Title } = Typography;

const AuthModal = ({ visible }) => {
    return (
        <Modal
            open={visible}
            closable={false}
            width={600}
            footer={null}
            centered
            styles={{
                mask: {
                    backdropFilter: 'blur(8px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)'
                }
            }}
        >
            <div style={{ textAlign: 'center' }}>
                <Title level={4}>Identifikatsiya amalga oshmadi, Telegram bot orqali kirishingiz kerak!</Title>

                <Button
                    type="primary"
                    size="large"
                    style={{ marginTop: 24, width: 200 }}
                    link
                    onClick={() => {
                        window.location.href = "https://t.me/Tester_uz_Robot";
                    }}
                >
                    Telegram botga o'tish
                </Button>
            </div>
        </Modal>
    );
};

export default AuthModal;
